var UserSearch = require("components/appdev/wizards/UserSearch");
var UsersList = require("components/appdev/wizards/UsersList");

class PowerDrillPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { users: null, selectedUser: null }
	}

	updateUserResults(users) {
		this.setState({ users: users });
	}

	render() {
		var headerDisplay = (
			<div className="headerSection">
				<header className="pageHeader">
					<h1>Power Drill</h1>
				</header>
			</div>
		);

		var userSearch = (
			<UserSearch updateResults={ this.updateUserResults } />
		);

		var users = this.state.users;
		if (users != undefined) {
			var resultsCount = (
				<p>
					<br/>
					{ users.length } { $wr.pluralize("result", users.length) }.
				</p>
			);

			var userResultsList = (
				<UsersList users={ users } />
			);
		}

		return (
			<div className="powerDrillPage container">
				{ headerDisplay }
				{ userSearch }
				{ resultsCount }
				{ userResultsList }
			</div>
		);
	}
};

PowerDrillPage.propTypes = PageStrictPropTypes({
});

module.exports = PowerDrillPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/PowerDrillPage.js